const FEATURES = [
  {
    id: 1,
    icon: 'ri-flashlight-fill',
    title: '极速更新',
    desc: '7×24小时全天候追踪全网热点，编辑团队与AI监测系统双重保障，确保最新黑料在第一时间送达瓜友手中。',
    bg: 'bg-primary-50',
    color: 'text-primary-500',
  },
  {
    id: 2,
    icon: 'ri-shield-check-fill',
    title: '多源验证',
    desc: '每条爆料均经过"三源交叉验证"流程，杜绝虚假信息。未确认内容明确标注"待证实"，对瓜友负责到底。',
    bg: 'bg-accent-50',
    color: 'text-accent-500',
  },
  {
    id: 3,
    icon: 'ri-smartphone-fill',
    title: '多端覆盖',
    desc: '支持网页端、iOS APP、Android APP多端同步浏览，账号数据云端互通。随时随地打开就能吃瓜，不错过任何精彩。',
    bg: 'bg-primary-50',
    color: 'text-primary-500',
  },
  {
    id: 4,
    icon: 'ri-team-fill',
    title: '百万瓜友',
    desc: '每日活跃用户超百万，评论区氛围活跃。瓜友之间理性讨论、互相补充信息，共同打造最优质的吃瓜社区。',
    bg: 'bg-accent-50',
    color: 'text-accent-500',
  },
  {
    id: 5,
    icon: 'ri-lock-fill',
    title: '隐私保护',
    desc: '严格保护爆料人身份信息，采用多层加密技术。所有投稿渠道均支持匿名提交，让你放心爆料、安心吃瓜。',
    bg: 'bg-primary-50',
    color: 'text-primary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-3">用心做好每一条内容，对得起每一位瓜友</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.id}
              className="group p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 text-center flex flex-col items-center gap-3"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${feature.bg}`}>
                <i className={`${feature.icon} ${feature.color} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}